<ng-container *ngIf="showFab$ | async">
  <button
    class="offer-preview-fab"
    [disabled]="isGenerating"
    (click)="openPreview()"
  >
    <mat-icon>visibility</mat-icon>
    <span *ngIf="!isGenerating">Visualizar proposta em PDF</span>
    <div *ngIf="isGenerating" class="loader">Loading...</div>
  </button>

  <hr-ol-pdf-acceptance
    style="display: none"
    #olPdfAcceptance
  ></hr-ol-pdf-acceptance>
</ng-container>

